import React from "react";

interface EventCardProps {
  img: string;
  name: string;
  startDate: string;
  endDate: string;
}

const EventCard: React.FC<EventCardProps> = ({
  img,
  name,
  startDate,
  endDate,
}) => {
  return (
    <div className="relative h-full w-full overflow-hidden rounded-[0.75rem]">
      <img src={img} alt={name} className="h-full w-full object-cover" />
      <div
        className="absolute top-0 h-full w-full p-6 text-white"
        style={{
          background:
            "linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100.04%)",
        }}
      >
        <p className="mb-[1px] text-sm font-semibold leading-[1.375rem] sm:text-base sm:leading-[1.5rem]">
          {name}
        </p>
        <p className="flex h-[1.125rem] items-center text-xs leading-none text-[#FFFFFF] sm:h-[1.375rem] sm:text-base">
          {startDate} ~ {endDate}
        </p>
      </div>
    </div>
  );
};

export default EventCard;
